<!-- src/App.vue -->
<template>
  <div id="app">    
    <Alert />
    <Loading />
    <router-view />
  </div>
</template>

<script lang="ts">
import Alert from './components/Alert.vue';
import Loading from './components/Loading.vue';

export default{
  name:"App",
  components:{Alert, Loading}
}
</script>

<style>
.data-page {
  @apply p-2 sm:p-5 min-h-screen;
}
.sr-input {
  @apply w-full h-11 px-3 py-2 rounded-md border text-base transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-black dark:text-white bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600;
}

.sr-error-input {
  @apply border-red-500;
}

/* List cards (components/cards). Long values (file names, paths) break anywhere so they
   never widen the card past the screen; labels still wrap only between words. */
.sr-card,
.sr-card-fluid {
  @apply p-4 sm:p-6 min-w-0;
  overflow-wrap: anywhere;
}
.sr-card label,
.sr-card-fluid label {
  overflow-wrap: normal;
}
/* Cards in a flex-wrap list: full width on phones, fixed 350px from sm up */
.sr-card {
  @apply my-2 sm:m-2 w-full sm:w-[350px];
}

</style>
